module.exports = __webpack_public_path__ + "img/section-break-white.b1deddae.svg";